import api from 'service/api'

const dponetAPI = api.create('dponet')

const list = async (params) =>
  await dponetAPI.get('/organization_quiz_templates', { params })

export default {
  list,
}
